module.exports = __webpack_public_path__ + "static/music-player-image-desktop-e36040859433b2d0f664302412b71f03.png";